import { defaultLightTheme, sharedThemeValues } from '../default/default';
export const elegantFontFamily = '"Playfair", "Figs", Raleway, serif';
const withFontFamily = (style, fontFamily) => ({
    ...style,
    untilMd: { ...style.untilMd, fontFamily },
    fromMd: { ...style.fromMd, fontFamily },
});
const elegantTypography = {
    ...sharedThemeValues.typography,
    headline: {
        ...sharedThemeValues.typography.headline,
        extraSmall: withFontFamily(sharedThemeValues.typography.body.large, elegantFontFamily),
    },
};
export const elegantTheme = {
    ...defaultLightTheme,
    typography: elegantTypography,
    name: 'elegant',
};
//# sourceMappingURL=elegant.js.map